import { render, staticRenderFns } from "./JsonSchemaTree.vue?vue&type=template&id=2cf49188&scoped=true&"
import script from "./JsonSchemaTree.vue?vue&type=script&lang=js&"
export * from "./JsonSchemaTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf49188",
  null
  
)

export default component.exports